import { jsx as _jsx } from "react/jsx-runtime";
import { constitucion } from '@academia-apolo/shared-content';
import { LawCodePage } from '@/features/student-penal-code/pages/LawCodePage';
/** Constitución Española de 1978 (texto consolidado BOE) — generic law viewer filtered by título. */
export function ConstitutionPage() {
    return (_jsx(LawCodePage, { data: constitucion, filterLevel: "titulo", searchPlaceholder: "Buscar por n\u00FAmero, palabra o frase (p. ej. '14', 'igualdad', 'Fuerzas y Cuerpos de Seguridad')\u2026" }));
}
//# sourceMappingURL=ConstitutionPage.js.map